import { Component, ViewChild,OnChanges,Output,EventEmitter, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { DialogBoxComponent } from './dialog/dialog-box.component';
import { DialogBoxCambioEstadoComponent } from './dialog/dialog-box-cambio-estado.component';
import { DialogBoxCopiarComponent } from './dialog/dialog-box-copiar.component';
import { DialogBoxPrintComponentEvaluacionDetallada } from './dialog/dialog-print-box.component';
import { DialogBoxPrintComponentEvaluacionControles } from 'app/main/apps/control/dialog/dialog-evaluacion-print-box.component';
import { DialogBoxPrintComponentEvaluacionControlesCriticos } from 'app/main/apps/control/dialog/dialog-evaluacion-controles-criticos-print-box.component';

import { DialogBoxPrintComponentEvaluacionMedidasDeContingencia } from './dialog/dialog-medidas-de-contingencia-print-box.component';
import { DialogBoxPrintComponentKri } from 'app/main/apps/kri/dialog/dialog-print-box.component';

import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { EvaluacionService } from '../../services/evaluacion.service';
import { Evaluacion } from 'app/main/models/evaluacion.model';
import { Riesgo } from 'app/main/models/riesgo.model';
import { getUsuariosNodo } from 'app/main/models/nodo-estructura-jerarquica.model';
import { SelectObjetivoDialogBoxComponent } from 'app/main/apps/objetivos/dialog-objetivo/select-objetivo-dialog-box.component';
import { DialogBoxComponentObjetivo } from 'app/main/apps/objetivos/dialog-objetivo/dialog-box.component';
import { SelectUsuarioDialogBoxComponent } from 'app/main/apps/usuarios/dialog/select-usuario-dialog-box.component';
import { SelectDimensionDialogBoxComponent} from 'app/main/apps/dimensiones-riesgos/dialog/select-dimension-dialog-box.component';
import { DialogBoxComponentDimension } from 'app/main/apps/dimensiones-riesgos/dialog/dialog-box.component';
import {SelectObjetivoRiesgoDialogBoxComponent } from 'app/main/apps/riesgo/dialog/select-objetivo-riesgo-dialog-box.component';
import {AddAInherenteDialogBoxComponent}  from 'app/main/apps/riesgo/dialog/add-a-inherente-dialog-box.component';
import {AddAResidualDialogBoxComponent}  from 'app/main/apps/riesgo/dialog/add-a-residual-dialog-box.component';
import {AddControlSugeridoDialogBoxComponent} from 'app/main/apps/control/dialog/add-control-sugerido-dialog-box.component';
import { AddKriDialogBoxComponent } from 'app/main/apps/kri/dialog/add-kri-dialog-box.component';
import { AddMedidaDeContingenciaDialogBoxComponent} from './dialog/add-medidas-de-contingencia-dialog-box.component';

import {MatTooltipModule} from '@angular/material/tooltip';


import { TipoEvaluacionService } from '../../services/tipo-evaluacion.service';
import { EscenarioService } from '../../services/escenario.service';
import { UsersService } from '../../services/users.service';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import {FormBuilder, FormGroup,FormControl, Validators} from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { AnalisisInherente } from 'app/main/models/analisis-inherente.model';
import { AnalisisResidual} from 'app/main/models/analisis-residual.model';
const Parser = require('expr-eval').Parser;
import * as d3 from 'd3-selection';
import {TipoUsuario} from '../../models/tipo-usuario.model';

@Component({
    selector   : 'evaluacion-view',
    templateUrl: './evaluacion-view.component.html',
    styleUrls  : ['./evaluacion-view.component.scss']
})
export class EvaluacionViewComponent
{
    evaluacion : Evaluacion = null;
    selectedStatus: number;
    preiniciadoFormGroup: FormGroup =  new FormGroup({firstName: new FormControl()});
    iniciadoFormGroup: FormGroup =  new FormGroup({firstName: new FormControl()});
    completadoFormGroup: FormGroup =  new FormGroup({firstName: new FormControl()});
    aprobadoFormGroup: FormGroup =  new FormGroup({firstName: new FormControl()});
    cerradoFormGroup: FormGroup =  new FormGroup({firstName: new FormControl()});
    isEditable = false;
    isReseted = false;
    action:string = "";

    displayedColumns: string[] = ['nombre','version','estructuraJerarquica','escenario','dueno','fechaInicio','fechaFin','estado','action'];
    displayedColumnsObjetivos: string[] = ['nombre', 'descripcion','action'];
    displayedColumnsUsuarios: string[] = ['nombre', 'correoElectronico','action'];
    displayedColumnsDimensiones: string[] = ['nombre', 'descripcion','categorias','action'];
    displayedColumnsRiesgos: string[] = ['objetivo', 'riesgo','action'];
    displayedColumnsAnalisisInherente : string[] = ['objetivo', 'riesgo','probabilidad','impacto','categoria','exposicion','clasificacion','action'];
    displayedColumnsKri: string[] = ['riesgo', 'nombre', 'estructura', 'nodo','responsable','action'];
    displayedColumnsMedidasDeContingencia: string[] = ['riesgo', 'medida', 'estructura', 'nodo', 'referente','responsable','action'];
    displayedColumnsAnalisisResidual : string[] = ['objetivo', 'riesgo','control','costo','esfuerzo','nroControles','probabilidad','impacto','exposicion','clasificacion','action'];
    displayedColumnsControlSugerido: string[] = ['riesgo', 'control', 'estructura', 'nodo', 'referente','responsable','action'];


    id :number = null;
    is_eval_creador: boolean = false;
    is_team_member: boolean = false;
    editar_nombre: boolean = false;
    editar_estado: boolean = false;
    editar_tipo:boolean = false;
    editar_estructura:boolean = false;
    editar_escenario: boolean = false;
    editar_dueno: boolean = false;
    editar_fecha_inicio: boolean = false;
    editar_fecha_fin: boolean = false;
    estados: any[] = ['PRE_INICIADO','INICIADO','COMPLETADO','APROBADO','CERRADO'];
    tiposEvaluacion = [];
    estructuraJerarquicas = [];
    escenarios = [];
    nodosEstructuraJerarquica = [];
    usuarios = [];
    riesgos = [];
    nombre:string ="";

    isThisStepDone0=false;
    isThisStepDone1=false;
    isThisStepDone2=false;
    isThisStepDone3=false;
    isThisStepDone4=false;
    isStepDone0 = "";
    isStepDone1 = "";
    isStepDone2 = "";
    isStepDone3 = "";
    isStepDone4 = "";
    selectedIndex = null;
    role = null;
    is_eval_owner = false;
    is_admin = false;
    is_audit = false;

    fechaInicio = null;
    fechaFin = null;

    //Cart Date
    multi: any[];
    view: any[] = [700, 350];
    reenderizarMapaDeCalro = true;

    dataSource = [];
    dataSourceI = [];
    dataSourceR = [];
    resultsList = [];

    pieDataExposiciones = [];

    legend: boolean = true;
    showLabels: boolean = true;
    animations: boolean = true;
    xAxis: boolean = true;
    yAxis: boolean = true;
    showYAxisLabel: boolean = true;
    showXAxisLabel: boolean = true;
    xAxisLabel: string = 'Probabilidad';
    yAxisLabel: string = 'Impacto';
    gradient: boolean = false;

    colorScheme = {
      domain: ['#34C229', '#F1F80C','#E44D25']
    };

    customColors = [];
    customColorsPie = [];

    actualizo_heatmap = false;
    riesgosAgregados = [];
    riesgosTooltip = {};

    
    @ViewChild('stepper') private stepper: MatStepper;
    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @ViewChild('tableAInherente', {static: true}) tableAInherente: MatTable<any>;
    @Output() selectedTabChange: EventEmitter<MatTabChangeEvent>

    //@ViewChild("stepper") stepper: MatStepper;


    constructor(public dialog: MatDialog,
                private storage: TokenStorageService,
                private service: EvaluacionService,
                public serviceTipoEvaluacion:TipoEvaluacionService,
                public serviceEscenarios:EscenarioService,
                private _snackBar: MatSnackBar,
                public translate: TranslateService,
                public router: Router,
                private route: ActivatedRoute) {}

    ngOnInit() {

      this.route.paramMap.subscribe(params => {
          this.id = parseInt(params.get('id'), 10);

          this.service.get(this.id).pipe().subscribe(req => {
            this.evaluacion = new Evaluacion(req.body);
            this.loadEvalData();

          });
      });

      this.serviceTipoEvaluacion.getAll(0,1000).pipe().subscribe(req => {
        this.tiposEvaluacion = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre
          };
        });
      });

      this.serviceEscenarios.getAll(0,1000).pipe().subscribe(req => {
        this.escenarios = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre
          };
        });
      });


    }

    loadEvalData(){

      var user = this.storage.getUser();
      this.role = this.storage.getRole();
      this.setActiveStep();

      this.fechaInicio = this.evaluacion.fechaInicio;
      this.fechaFin = this.evaluacion.fechaFin;

      if(this.role!=undefined && this.role.includes(2))
        this.is_admin = true;

      if(this.role!=undefined && this.role.includes(1))
        this.is_audit = true;

      if(this.evaluacion.creador.correoElectronico.trim() == user.trim()){
          this.is_eval_creador = true;
          this.is_team_member = true;
      }

      if(this.evaluacion.owner.correoElectronico.trim() == user.trim()){
            this.is_eval_owner = true;
            this.is_team_member = true;
      }

      this.evaluacion.usuarios.forEach(element => {
        if(element.correoElectronico.trim() == user.trim())
          this.is_team_member = true;
      });

      this.evaluacion.riesgos.forEach(riesgo => {

        if(riesgo.analisisInherente.length>0){
            riesgo.analisisInherente.forEach(ai => {
              if(riesgo.topAnalisisInherente==null){
                riesgo.topAnalisisInherente= ai;
              }else if(riesgo.topAnalisisInherente.exposicion<ai.exposicion){
                riesgo.topAnalisisInherente= ai;
              }
            });
        }else{
          riesgo.topAnalisisInherente = new AnalisisInherente({});
        }

        riesgo.analisisResidual.forEach(ar => {
          if(riesgo.topAnalisisResidual==null){
            riesgo.topAnalisisResidual= ar;
          }else if(riesgo.topAnalisisResidual.exposicion>ar.exposicion){
            riesgo.topAnalisisResidual= ar;
          }
        });


        riesgo.cantidadControles = 0;
        riesgo.analisisResidual.forEach(element => {
          if(element.control!=null && element.control!="")
            riesgo.cantidadControles +=1;
        });
      });

      this.evaluacion.medidasDeContingencia = [...this.evaluacion.medidasDeContingencia];
      this.evaluacion.kris = [...this.evaluacion.kris];
      this.evaluacion.controlesSugeridos = [...this.evaluacion.controlesSugeridos];

      this.calcularResultadosOriginal();

    }

    print():void{

      const dialogRef = this.dialog.open(DialogBoxPrintComponentEvaluacionDetallada, {
        panelClass: 'my-full-screen-dialog',
        width: '95%',
        maxWidth: '95%',
        data: {action:"Print", obj:this.evaluacion},
        autoFocus: false,
        disableClose: true
      });

    }

    printControlesSugeridos():void{

      const dialogRef = this.dialog.open(DialogBoxPrintComponentEvaluacionControles, {
        panelClass: 'my-full-screen-dialog',
        width: '95%',
        maxWidth: '95%',
        data: {action:"Print", obj:this.evaluacion},
        autoFocus: false,
        disableClose: true
      });

    }


    printControlesCriticos():void{

      const dialogRef = this.dialog.open(DialogBoxPrintComponentEvaluacionControlesCriticos, {
        panelClass: 'my-full-screen-dialog',
        width: '95%',
        maxWidth: '95%',
        data: {action:"Print", obj:this.evaluacion},
        autoFocus: false,
        disableClose: true
      });

    }


    printMedidasDeContingencia():void{

      const dialogRef = this.dialog.open(DialogBoxPrintComponentEvaluacionMedidasDeContingencia, {
        panelClass: 'my-full-screen-dialog',
        width: '95%',
        maxWidth: '95%',
        data: {action:"Print", obj:this.evaluacion},
        autoFocus: false,
        disableClose: true
      });

    }

    printKris():void{

      const dialogRef = this.dialog.open(DialogBoxPrintComponentKri, {
        panelClass: 'my-full-screen-dialog',
        width: '95%',
        maxWidth: '95%',
        data: {action:"Print", obj:this.evaluacion},
        autoFocus: false,
        disableClose: true
      });

    }


    navegateTo(url, id): void  {
        this.router.navigateByUrl(url).then( (e) => {
          if (e) {
            console.log("Navigation is successful!");
          } else {
            console.log("Navigation has failed!");
          }
        });
    }

    openDialog(): void {
      var user = this.storage.getUser();
      var obj = {ownerSelector:true,tipoEvaluacion:this.evaluacion.tipo,tipoUsuario:4,usuario: user};
      const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
        width: '100%',
        data: obj,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

        this.service.editEstructura(this.evaluacion.id,
          {estructura:result.data.estructura,nodo:result.data.nodo}).pipe().subscribe(req => {
            this.evaluacion.nodoEstructuraJerarquica = result.data.nodo;
            this.evaluacion.estructuraJerarquica = result.data.estructura;
            this.evaluacion.owner = result.data.usuario;
            this.selectDueno({value:result.data.usuario});

        },
        err => {
          this.openSnackBar("No se pudo modificar la estructura, ocurrió un error.","Cerrar");
        });

      });
    }

    openDialogEstructuraFromTipoEvaluacion(tipo): void {
      var obj = {ownerSelector:true,tipoEvaluacion:this.evaluacion.tipo,tipoUsuario:4};
      const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
        width: '100%',
        data: obj,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

        if(tipo.value!=null && result.data!=null && result.data.estructura!=null && result.data.nodo!=null)
        this.service.editTipo(this.evaluacion.id,tipo.value).pipe().subscribe(req => {
          this.evaluacion.tipo = tipo.value;
          this.evaluacion.nodoEstructuraJerarquica = null;
          this.evaluacion.estructuraJerarquica = null;
          this.evaluacion.owner = null;

          this.service.editEstructura(this.evaluacion.id,
            {estructura:result.data.estructura,nodo:result.data.nodo}).pipe().subscribe(req => {
              this.evaluacion.nodoEstructuraJerarquica = result.data.nodo;
              this.evaluacion.estructuraJerarquica = result.data.estructura;
              this.evaluacion.owner = result.data.usuario;
              this.selectDueno({value:result.data.usuario});

          },
          err => {
            this.openSnackBar("No se pudo modificar la estructura, ocurrió un error.","Cerrar");
          });

        },
        err => {
          this.openSnackBar("No se pudo modificar el estado, ocurrió un error.","Cerrar");
        });



      });
    }

    /////////////OBJETIVOS ////////////////////////////

    

    openDialogObjetivos(action, obj): void {
      const dialogRef = this.dialog.open(SelectObjetivoDialogBoxComponent, {
        width: '100%',
        data: {obj: obj, action:action},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.event === 'Add'){
          this.addRowDataObjetivos(result.data);
        } else if (result.event === 'Delete') {
          this.deleteRowDataObjetivos(result.data);
        }
      });
    }

    addRowDataObjetivos(row_obj): void {

      var tieneElObjetivo = false;
      this.evaluacion.objetivos.forEach(element => {
        if(element.id === row_obj.id)
          tieneElObjetivo = true;
      });

      if(tieneElObjetivo){
        this.openSnackBar("El objetivo seleccionado ya esta asociado a la evaluación.","Cerrar");
      }else{
        this.evaluacion.objetivos.push(row_obj);
        this.evaluacion.objetivos = [...this.evaluacion.objetivos];

        this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
          this.openSnackBar("Se ingresó el objetivo correctamente.","Cerrar");
        },
        err => {
          this.openSnackBar("No se pudo agregar el objetivo, ocurrió un error.","Cerrar");

        });
      }

    }


    openDialogEditObjetivo(action, obj): void {
      var objOriginal = obj;
      var objIdOriginal = obj.id;
      const dialogRef = this.dialog.open(DialogBoxComponentObjetivo, {
        width: '100%',
        data: {action:action, obj:obj, dataSource:this.evaluacion.objetivos},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

        var objetivoNuevo = result.data;
        if(result.dataSource!=null && result.event!="Cancel"){

          this.evaluacion.objetivos = [...result.dataSource];

          if(objetivoNuevo!=null && objOriginal!=null && objetivoNuevo.id!=null && objIdOriginal!=null &&
            objetivoNuevo.id !== objIdOriginal){
              //Hay que actualizar los riesgos con el nuevo objetivo.
                for(var i=0; this.evaluacion.riesgos.length>i; i++){
                    if(this.evaluacion.riesgos[i].objetivo.id === objIdOriginal)
                    this.evaluacion.riesgos[i].objetivo = objetivoNuevo;
                }

          }

          this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
            this.openSnackBar("Se modificó el objetivo correctamente.","Cerrar");
          },
          err => {
            this.openSnackBar("No se pudo modificar el objetivo, ocurrió un error.","Cerrar");

          });
        }
        //this.table.renderRows();
      });
    }



    deleteRowDataObjetivos(row_obj): void {

       //Se limpian los objetivo_riesgos asociados al objetivo.
       for(var i=0; this.evaluacion.riesgos.length>i; i++){
         console.log("Objetivo:" +row_obj.id +" / "+ row_obj.nombre +" - ObjRiesgo:"+this.evaluacion.riesgos[i].objetivo.id+" + "+ this.evaluacion.riesgos[i].objetivo.nombre);
        if(this.evaluacion.riesgos[i].objetivo.id === row_obj.id)
          this.deleteRowDataRiesgos(this.evaluacion.riesgos[i]);
      }

      //this.dataSource = this.dataSource.filter();
      this.evaluacion.objetivos = this.evaluacion.objetivos.filter((value, key) => {
        return value.id !== row_obj.id;
      });

      this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {

        this.openSnackBar("Se eliminó el objetivo correctamente.","Cerrar");
      },
      err => {
        this.openSnackBar("No se pudo eliminar el objetivo, ocurrió un error.","Cerrar");

      });
    }


    //////////FIN OBJETIVOS ///////////////////////

    /////////////Usuarios ////////////////////////////

    

    openDialogUsuarios(action, obj): void {
      obj.action = action;
      var usuarios = getUsuariosNodo(this.evaluacion.nodoEstructuraJerarquica);

        usuarios = usuarios.filter(usuario =>
            usuario.tipos.some((tipo: TipoUsuario) => tipo.id === 3)
        );

      var tieneOwner = false;

      this.evaluacion.nodoEstructuraJerarquica.usuarios.forEach(usuario => {

        if(usuario.id === this.evaluacion.owner.id)
          tieneOwner=true;
      });

      if(!tieneOwner)
        usuarios.push(this.evaluacion.owner);

      const dialogRef = this.dialog.open(SelectUsuarioDialogBoxComponent, {
        width: '100%',
        data: {action: action, obj: obj, usuarios: usuarios},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.event === 'Add'){
          this.addRowDataUsuarios(result.data);
        } else if (result.event === 'Update') {
          this.updateRowDataUsuarios(result.data);
        } else if (result.event === 'Delete') {
          this.deleteRowDataUsuarios(result.data);
        }
      });
    }

    addRowDataUsuarios(row_obj): void {
      this.evaluacion.usuarios.push(row_obj);
      this.evaluacion.usuarios = [...this.evaluacion.usuarios];

      this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
        this.openSnackBar("Se ingresó el usuario correctamente.","Cerrar");
      },
      err => {
        this.openSnackBar("No se pudo agregar el usuario, ocurrió un error.","Cerrar");

      });
    }

    updateRowDataUsuarios(row_obj): void {
      //this.evaluacion.objetivos.push(row_obj);
    }

    deleteRowDataUsuarios(row_obj): void {
      this.evaluacion.usuarios = this.evaluacion.usuarios.filter((value, key) => {
        return value.id !== row_obj.id;
      });

      this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
        this.openSnackBar("Se eliminó el usuario correctamente.","Cerrar");
      },
      err => {
        this.openSnackBar("No se pudo eliminar el usuario, ocurrió un error.","Cerrar");

      });

    }


    //////////FIN Usuarios ///////////////////////

    /////////////Dimensiones ////////////////////////////

    

    openDialogDimensiones(action, obj): void {
      obj.action = action;
      const dialogRef = this.dialog.open(SelectDimensionDialogBoxComponent, {
        width: '100%',
        data: {action: action, obj: obj},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.event === 'Add'){
          this.addRowDataDimensiones(result.data);
        } else if (result.event === 'Update') {
          this.updateRowDataDimensiones(result.data);
        } else if (result.event === 'Delete') {
          this.deleteRowDataDimensiones(result.data);
        }
      });
    }

    openDialogEditDimensiones(action, obj): void {
      var objOriginal = obj;
      const dialogRef = this.dialog.open(DialogBoxComponentDimension, {
        width: '100%',
        data: {action:action, obj:obj, dataSource:this.evaluacion.dimensiones},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

        if(result.dataSource!=null && result.event  !="Cancel"){

          this.evaluacion.dimensiones = [...result.dataSource];

          this.evaluacion.dimensiones = this.evaluacion.dimensiones.filter((value, key) => {
            return value.id !== objOriginal.id;
          });

          this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
            this.openSnackBar("Se modificó la dimensión correctamente.","Cerrar");
          },
          err => {
            this.openSnackBar("No se pudo modificar la dimensión, ocurrió un error.","Cerrar");

          });
        }
        //this.table.renderRows();
      });
    }

    addRowDataDimensiones(row_obj): void {
      this.evaluacion.dimensiones = [];
      this.evaluacion.dimensiones.push(row_obj);
      this.evaluacion.dimensiones = [...this.evaluacion.dimensiones];

      this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
        this.openSnackBar("Se agregó la dimension correctamente.","Cerrar");
      },
      err => {
        this.openSnackBar("No se pudo agregar la dimension, ocurrió un error.","Cerrar");

      });

    }

    updateRowDataDimensiones(row_obj): void {
      //this.evaluacion.dimensiones.push(row_obj);
    }

    deleteRowDataDimensiones(row_obj): void {
      this.evaluacion.dimensiones = this.evaluacion.dimensiones.filter((value, key) => {
        return value.id !== row_obj.id;
      });

      this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
        this.openSnackBar("Se eliminó la dimension correctamente.","Cerrar");
      },
      err => {
        this.openSnackBar("No se pudo elimniar la dimension, ocurrió un error.","Cerrar");

      });
    }


    //////////FIN dimensiones ///////////////////////

    /////////////Riesgos ////////////////////////////

    

    openDialogRiesgos(action, obj): void {

      if(this.evaluacion.objetivos!=null && this.evaluacion.objetivos.length>0){

        const dialogRef = this.dialog.open(SelectObjetivoRiesgoDialogBoxComponent, {
          width: '100%',
          data: {action:action, obj:obj, objetivos: this.evaluacion.objetivos},
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result.event === 'Add'){
            this.addRowDataRiesgos(result.data);
          } else if (result.event === 'Update') {
            this.updateRowDataRiesgos(result.data);
          } else if (result.event === 'Delete') {
            this.deleteRowDataRiesgos(result.data);
          }
        });
      }else{
        this.openSnackBar("Debe ingresar un objetivo previamente.","Cerrar");
      }
    }

    openDialogEditRiesgo(action, obj): void {
      var objOriginal = obj;
      const dialogRef = this.dialog.open(SelectObjetivoRiesgoDialogBoxComponent, {
        width: '100%',
        data: {action:action, obj:obj, objetivos: this.evaluacion.objetivos},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

        if(result.event!="Cancel"){

          this.evaluacion.riesgos = this.evaluacion.riesgos.filter((value, key) => {
            return value.id !== objOriginal.id;
          });

          this.evaluacion.riesgos.push(result.data);
          this.evaluacion.riesgos = [...this.evaluacion.riesgos];

          this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
            this.openSnackBar("Se modificó el riesgo correctamente.","Cerrar");
          },
          err => {
            this.openSnackBar("No se pudo modificar el riesgo, ocurrió un error.","Cerrar");

          });
        }
        //this.table.renderRows();
      });
    }

    addRowDataRiesgos(row_obj): void {
      var tieneRiesgo = false;
      this.evaluacion.riesgos.forEach(element => {
        if(element.objetivo.id == row_obj.objetivo.id && element.riesgo.id == row_obj.riesgo.id)
          tieneRiesgo = true;
      });

      if(!tieneRiesgo){
        this.evaluacion.riesgos.push(row_obj);
        //this.evaluacion.riesgos = [...this.evaluacion.riesgos];

        this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
          
            this.evaluacion.riesgos = [...req.body.riesgos];
            this.loadEvalData();
            this.openSnackBar("Se agregó el riesgo correctamente.","Cerrar");
          
        },
        err => {
          this.openSnackBar("No se pudo agregar el riesgo, ocurrió un error.","Cerrar");

        });

      }else{
        this.openSnackBar("El riesgo seleccionado ya existe dentro de la evaluación","Cerrar");
      }
    }

    updateRowDataRiesgos(row_obj): void {
      //this.evaluacion.dimensiones.push(row_obj);
    }

    deleteRowDataRiesgos(row_obj): void {

      /*this.evaluacion.riesgos = this.evaluacion.riesgos.filter((value, key) => {
        return !(value.objetivo.id == row_obj.objetivo.id && value.riesgo.id == row_obj.riesgo.id);
      });*/

      this.service.deleteRiesgos(this.evaluacion.id,row_obj.id).pipe().subscribe(req => {
        this.openSnackBar("Se eliminó el riesgo correctamente.","Cerrar");
        this.evaluacion = req.body;
        this.ngOnInit();
      },
      err => {
        this.openSnackBar("No se pudo eliminar el riesgo, ocurrió un error.","Cerrar");

      });
    }


    //////////FIN riesgos ///////////////////////



    /////////////Analisis Inherente ////////////////////////////



    openDialogAnalisisInherente(action, obj): void {

      const dialogRef = this.dialog.open(AddAInherenteDialogBoxComponent, {
        width: '100%',
        data: {action: 'Update',objetivoRiesgo: obj, escenario: this.evaluacion.escenario,dimensiones: this.evaluacion.dimensiones,estructura:this.evaluacion.estructuraJerarquica},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

        obj = result.data;
        if(obj!=null)
          this.actualizarProbabilidadRiesgo(obj);

        this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
          //this.openSnackBar("Se actualizó el analisis inherente correctamente.","Cerrar");
        },
        err => {
          this.openSnackBar("No se pudo actualizar el analisis inherente, ocurrió un error.","Cerrar");

        });

      });
    }

    //////////FIN Analisis Inherente ///////////////////////

    /////////////Analisis Inherente ////////////////////////////

    


    openDialogAnalisisResidual(action, obj): void {
      obj.action = action;
      const dialogRef = this.dialog.open(AddAResidualDialogBoxComponent, {
        width: '100%',
        data: {objetivoRiesgo: obj, escenario: this.evaluacion.escenario,
          dimensiones: this.evaluacion.dimensiones,
          estructura:this.evaluacion.estructuraJerarquica,
          nodo:this.evaluacion.nodoEstructuraJerarquica,},
          disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

        //obj = result.data;
        this.evaluacion.riesgos = this.evaluacion.riesgos.filter((value, key) => {
          if (value.id!=null && result.data.id!=null && value.id === result.data.id) {
            value.analisisResidual = result.data.analisisResidual;
          }else if(value.riesgo.id === result.data.riesgo.id && 
                    value.objetivo.id === result.data.objetivo.id){
                value.analisisResidual = result.data.analisisResidual;
          }
          return true;
        });

        this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
            this.reenderizarMapaDeCalro = false;
            this.actualizo_heatmap = false;
            setTimeout(() => {
                this.reenderizarMapaDeCalro = true;
            }, 1000); // Esto
            setTimeout(() => {
                this.actualizarColores();
            }, 1000); // Esto


        },
        err => {
          this.openSnackBar("No se pudo actualizar el analisis residual, ocurrió un error.","Cerrar");

        });
      });
    }


    //////////FIN Analisis Inherente ///////////////////////


    /////////////Controles Sugerido ////////////////////////////

    

    openDialogControlSugerido(action, obj): void {

      this.riesgos = [];
      var agregadosId = [];
      this.evaluacion.riesgos.forEach(element => {
        if(agregadosId.indexOf(element.riesgo.id)==-1){
          this.riesgos.push(element.riesgo);
          agregadosId.push(element.riesgo.id);
        }
      });

      const dialogRef = this.dialog.open(AddControlSugeridoDialogBoxComponent, {
        width: '100%',
        data: {escenario: this.evaluacion.escenario, obj:obj,action:action,
                estructura:this.evaluacion.estructuraJerarquica,
                nodo:this.evaluacion.nodoEstructuraJerarquica,
                riesgos: this.riesgos,
                controlesSugeridos: this.evaluacion.controlesSugeridos},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.event === 'Add'){
          this.addRowDataControlSugerido(result.data);
        } else if (result.event === 'Update') {
          this.updateRowDataControlSugerido(result.data);
        } else if (result.event === 'Delete') {
          this.deleteRowDataControlSugerido(result.data);
        }
      });
    }

    addRowDataControlSugerido(row_obj): void {
      this.evaluacion.controlesSugeridos.push(row_obj);
      //this.evaluacion.controlesSugeridos = [...this.evaluacion.controlesSugeridos];

      this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
        this.evaluacion = req.body;
        this.loadEvalData();
        this.evaluacion.controlesSugeridos = [...this.evaluacion.controlesSugeridos];
        //this.openSnackBar("Se ingresó el control correctamente.","Cerrar");
      },
      err => {
        this.openSnackBar("No se pudo ingresar el control, ocurrió un error.","Cerrar");

      });
    }

    updateRowDataControlSugerido(row_obj): void {

      /*this.evaluacion.controlesSugeridos.forEach(element => {
        if(element.id == row_obj.id)
          element = row_obj;
      });*/

      this.service.edit(this.evaluacion.id, this.evaluacion).pipe(first()).subscribe(
        data => {
            console.log(data);
            this.evaluacion.controlesSugeridos = [...data.body.controlesSugeridos];

            this.evaluacion.controlesSugeridos.sort((a, b) => (a.riesgo.nombre > b.riesgo.nombre) ? 1 : -1);
            //this.openSnackBar("Se actualizó el control sugerido correctamente.","Cerrar");
        },
        error => {
          console.log(error);
          this.openSnackBar("No se pudo actualizar el control sugerido, ocurrió un error.","Cerrar");
        }
      );
    }

    deleteRowDataControlSugerido(row_obj): void {

      this.service.deleteControlSugerido(this.evaluacion.id,row_obj.id).pipe().subscribe(req => {
        this.openSnackBar("Se eliminó el control correctamente.","Cerrar");
        this.evaluacion.controlesSugeridos = this.evaluacion.controlesSugeridos.filter(
          obj =>
          ((obj.id!== null && obj.id !== row_obj.id) || (obj.id === null && obj !== row_obj))
        );
        this.evaluacion.controlesSugeridos = [...this.evaluacion.controlesSugeridos];


      },
      err => {
        this.openSnackBar("No se pudo eliminar el control, ocurrió un error.","Cerrar");

      });
    }


    //////////FIN controles sugeridos ///////////////////////

    /////////////Controles KRI ////////////////////////////

    openDialogKri(action, obj): void {

      this.riesgos = [];
      var agregadosId = [];
      this.evaluacion.riesgos.forEach(element => {
        if(agregadosId.indexOf(element.riesgo.id)==-1){
          this.riesgos.push(element.riesgo);
          agregadosId.push(element.riesgo.id);
        }
      });

      const dialogRef = this.dialog.open(AddKriDialogBoxComponent, {
        width: '100%',
        data: {escenario: this.evaluacion.escenario, obj:obj,action:action,
          estructura:this.evaluacion.estructuraJerarquica,
          nodo:this.evaluacion.nodoEstructuraJerarquica,riesgos:this.riesgos,
          evaluacion: {id:this.evaluacion.id, estado:this.evaluacion.estado} },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.event === 'Add'){
          this.addRowDataKri(result.data);
        } else if (result.event === 'Update') {
          this.updateRowDataKri(result.data);
        } else if (result.event === 'Delete') {
          this.deleteRowDataKri(result.data);
        }
      });
    }

    addRowDataKri(row_obj): void {
      this.evaluacion.kris.push(row_obj);
      //this.evaluacion.kris = [...this.evaluacion.kris];

      this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
        this.evaluacion = req.body;
        this.loadEvalData();
        this.evaluacion.kris = [...this.evaluacion.kris];
        //this.openSnackBar("Se ingresó el kri correctamente.","Cerrar");
      },
      err => {
        this.openSnackBar("No se pudo ingresar el kri, ocurrió un error.","Cerrar");

      });
    }

    updateRowDataKri(row_obj): void {

      this.evaluacion.kris.forEach(element => {
        if(element.id == row_obj.id)
          element.mediciones = row_obj.mediciones;
      });

      this.evaluacion.kris.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
      /*
      this.evaluacion.kris.forEach(element => {
        if(element.id == row_obj.id)
          element = row_obj;
      });

      this.service.edit(this.evaluacion.id, this.evaluacion).pipe(first()).subscribe(
        data => {
            console.log(data);
            this.evaluacion.kris = [...data.body.kris];

            this.evaluacion.kris.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
            this.openSnackBar("Se actualizó el kri correctamente.","Cerrar");
        },
        error => {
          console.log(error);
          this.openSnackBar("No se pudo actualizar el kri, ocurrió un error.","Cerrar");
        }
      );*/
    }

    deleteRowDataKri(row_obj): void {

      this.service.deleteKri(this.evaluacion.id,row_obj.id).pipe().subscribe(req => {
        this.openSnackBar("Se eliminó el kri correctamente.","Cerrar");
        this.evaluacion.kris = this.evaluacion.kris.filter(obj => (obj.id!= null && obj.id !== row_obj.id) || (obj.id== null && obj !== row_obj));

      },
      err => {
        this.openSnackBar("No se pudo eliminar el kri, ocurrió un error.","Cerrar");

      });
    }


    //////////FIN controles sugeridos ///////////////////////

    /////////////Controles Sugerido ////////////////////////////


    openDialogMedidasDeContingencia(action, obj): void {

      this.riesgos = [];
      var agregadosId = [];
      this.evaluacion.riesgos.forEach(element => {
        if(agregadosId.indexOf(element.riesgo.id)==-1){
          this.riesgos.push(element.riesgo);
          agregadosId.push(element.riesgo.id);
        }
      });

      const dialogRef = this.dialog.open(AddMedidaDeContingenciaDialogBoxComponent, {
        width: '100%',
        data: {escenario: this.evaluacion.escenario, obj:obj,action:action,
          estructura:this.evaluacion.estructuraJerarquica,
          nodo:this.evaluacion.nodoEstructuraJerarquica,
          riesgos:this.riesgos },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.event === 'Add'){
          this.addRowDataMedidasDeContingencia(result.data);
        } else if (result.event === 'Update') {
          this.updateRowDataMedidasDeContingencia(result.data);
        } else if (result.event === 'Delete') {
          this.deleteRowDataMedidasDeContingencia(result.data);
        }
      });
    }

    addRowDataMedidasDeContingencia(row_obj): void {
      this.evaluacion.medidasDeContingencia.push(row_obj);
      //this.evaluacion.medidasDeContingencia = [...this.evaluacion.medidasDeContingencia];

      this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
        this.evaluacion = req.body;
        this.loadEvalData();
        this.evaluacion.medidasDeContingencia = [...this.evaluacion.medidasDeContingencia];
        //this.openSnackBar("Se ingresó la medida de contingencia correctamente.","Cerrar");
      },
      err => {
        this.openSnackBar("No se pudo ingresar la medida de contingencia, ocurrió un error.","Cerrar");

      });
    }

    updateRowDataMedidasDeContingencia(row_obj): void {

      this.evaluacion.medidasDeContingencia.forEach(element => {
        if(element.id == row_obj.id)
          element = row_obj;
      });

      this.service.edit(this.evaluacion.id, this.evaluacion).pipe(first()).subscribe(
        data => {
            console.log(data);
            this.evaluacion.medidasDeContingencia = [...data.body.medidasDeContingencia];

            this.evaluacion.medidasDeContingencia.sort((a, b) => (a.riesgo.nombre > b.riesgo.nombre) ? 1 : -1);
            //this.openSnackBar("Se actualizó la medida de contingencia.","Cerrar");
        },
        error => {
          console.log(error);
          this.openSnackBar("No se pudo la medida de contingencia, ocurrió un error.","Cerrar");
        }
      );
    }

    deleteRowDataMedidasDeContingencia(row_obj): void {

      this.service.deleteMedidaDeContingencia(this.evaluacion.id,row_obj.id).pipe().subscribe(req => {
        this.openSnackBar("Se eliminó la medida de contingencia correctamente.","Cerrar");

        this.evaluacion.medidasDeContingencia = this.evaluacion.medidasDeContingencia.filter(obj => (obj.id!= null && obj.id !== row_obj.id) || (obj.id== null && obj !== row_obj));

      },
      err => {
        this.openSnackBar("No se pudo eliminar la medida de contingencia, ocurrió un error.","Cerrar");

      });
    }


    //////////FIN controles sugeridos ///////////////////////

    selectEstado():void{

      this.editar_estado = false;

    }

    updateName(nombre):void{
      this.editar_nombre = false;

      this.service.editNombre(this.evaluacion.id,nombre).pipe().subscribe(req => {
        this.evaluacion.nombre = nombre;
      },
      err => {
      this.openSnackBar("No se pudo modificar el estado, ocurrió un error.","Cerrar");
      });
    }

    selectTipo(tipo):void{
      this.editar_tipo = false;

      this.openDialogEstructuraFromTipoEvaluacion(tipo);

    }


    selectEscenario(escenario):void{
      this.editar_escenario = false;

      this.service.editEscenario(this.evaluacion.id,escenario.value).pipe().subscribe(req => {
        this.evaluacion.escenario = req.body;


        //Recalcular los analisisInherente y AnalisisResidual segun nuevo escenario.
        this.actualizarRiesgosPorCambioDeEvaluacion();
        this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
          //this.openSnackBar("Se actualizó el riesgo correctamente.","Cerrar");
          //this.evaluacion = {...this.evaluacion};
          window.location.reload();
        },
        err => {
          this.openSnackBar("No se pudo actualizar el riesgo, ocurrió un error.","Cerrar");

        });


      },
      err => {
        this.openSnackBar("No se pudo modificar el escenario, ocurrió un error.","Cerrar");
      });
    }

    selectDueno(owner):void{
      this.editar_dueno = false;

      this.service.editOwner(this.evaluacion.id,owner.value).pipe().subscribe(req => {
        this.evaluacion.owner = owner.value;
        window.location.reload();
      },
      err => {
        this.openSnackBar("No se pudo modificar el dueño, ocurrió un error.","Cerrar");
      });
    }

    selectFechaInicio(fecha):void{
      this.editar_fecha_inicio = false;

      if(new Date(fecha.value)>new Date(this.evaluacion.fechaFin)){
        alert("La fecha de inicio no puede ser posterior a la fecha de finalización");
        this.fechaInicio = this.evaluacion.fechaInicio;
      }else{
        this.service.editFechaInicio(this.evaluacion.id,fecha.value).pipe().subscribe(req => {
          this.evaluacion.fechaInicio = fecha.value;
        },
        err => {
          this.openSnackBar("No se pudo modificar la fecha de inicio, ocurrió un error.","Cerrar");
        });
      }
    }

    selectFechaFin(fecha):void{
      this.editar_fecha_fin = false;
      if(new Date(fecha.value)<new Date(this.evaluacion.fechaInicio)){
        alert("La fecha de finalización no puede ser anterior a la fecha de inicio");
        this.evaluacion.fechaFin = this.evaluacion.fechaFin;
      }else{
        this.service.editFechaFin(this.evaluacion.id,fecha.value).pipe().subscribe(req => {
          this.evaluacion.fechaFin = fecha.value;
        },
        err => {
          this.openSnackBar("No se pudo modificar la fecha de finalización, ocurrió un error.","Cerrar");
        });
      }
    }

    versionar():void{

      const dialogRef = this.dialog.open(DialogBoxCopiarComponent, {
        width: '100%',
        data: {action:'Versionar',obj:this.evaluacion},
        disableClose: true
      });


    }

    copiar():void{
      const dialogRef = this.dialog.open(DialogBoxCopiarComponent, {
        width: '100%',
        data: {action:'Copiar',obj:this.evaluacion},
        disableClose: true
      });
    }

    changeStatus(event: any):void{
      
      var ss = this.selectedStatus;
      var status = "";
      if(ss==0 && (this.is_eval_owner || this.is_eval_creador) && this.evaluacion.estado=="PRE_INICIADO" && this.role.includes(4)){
        status = "INICIADO";
      }
      if(ss==1 && this.is_team_member && this.evaluacion.estado=="INICIADO" && this.evaluacion.riesgos.length>0 &&
        this.evaluacion.riesgos[0].topAnalisisInherente!=null && this.evaluacion.riesgos[0].topAnalisisInherente.exposicion>0){
        status = "COMPLETADO";
      }
      if(ss==2 &&  this.is_eval_owner && this.evaluacion.estado=="COMPLETADO" && this.role.includes(4)){
        status = "APROBADO";
      }
      if(ss==3 && this.is_eval_owner  && this.evaluacion.estado=="APROBADO" && this.role.includes(4)){
        status = "CERRADO";
      }

      if(status!=""){

        const dialogRef = this.dialog.open(DialogBoxCambioEstadoComponent, {
          width: '100%',
          data: {action:status},
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result.event != 'Cancel'){
              this.service.editStatus(this.evaluacion.id,status).pipe().subscribe(req => {
              this.evaluacion.estado = status;
              this.setActiveStep();
              this.openSnackBar("Se modificó el estado de la evaluación a "+status,"Cerrar");
            },
            err => {
              this.openSnackBar("No se pudo modificar el estado, ocurrió un error.","Cerrar");
            });
          }else{
            this.setActiveStep();
          }
        });

      }

    }

    setActiveStep():void{
      this.isThisStepDone0=false;
      this.isThisStepDone1=false;
      this.isThisStepDone2=false;
      this.isThisStepDone3=false;
      this.isThisStepDone4=false;
      this.isStepDone0 = "";
      this.isStepDone1 = "";
      this.isStepDone2 = "";
      this.isStepDone3 = "";
      this.isStepDone4 = "";
      if(this.evaluacion.estado=="PRE_INICIADO"){
        this.selectedStatus = 0;

      }
      if(this.evaluacion.estado=="INICIADO"){
        this.isThisStepDone0=false;
        this.isStepDone0 = "done";
        this.selectedStatus = 1;

      }
      if(this.evaluacion.estado=="COMPLETADO"){
        this.isThisStepDone0=false;
        this.isStepDone0 = "done";
        this.isThisStepDone1=false;
        this.isStepDone1 = "done";
        this.selectedStatus = 2;

      }
      if(this.evaluacion.estado=="APROBADO"){
        this.isThisStepDone0=false;
        this.isStepDone0 = "done";
        this.isThisStepDone1=false;
        this.isStepDone1 = "done";
        this.isThisStepDone2=false;
        this.isStepDone2 = "done";
        this.selectedStatus = 3;

      }
      if(this.evaluacion.estado=="CERRADO"){
        this.isThisStepDone0=false;
        this.isStepDone0 = "done";
        this.isThisStepDone1=false;
        this.isStepDone1 = "done";
        this.isThisStepDone2=false;
        this.isStepDone2 = "done";
        this.isThisStepDone3=false;
        this.isStepDone3= "done";
        this.isThisStepDone4=false;
        this.isStepDone4 = "done";
        this.selectedStatus = 4;

      }

      this.stepper.linear = false;
      this.stepper.selectedIndex = this.selectedStatus;
      setTimeout(() => {
         this.stepper.linear = true;
      });

    }

    rechazar():void{

      const dialogRef = this.dialog.open(DialogBoxCambioEstadoComponent, {
        width: '100%',
        data: {action:"Rechazar"},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.event != 'Cancel'){
          this.service.editStatusRechazo(this.evaluacion.id,"INICIADO",result.motivo).pipe().subscribe(req => {
            this.evaluacion.estado = "INICIADO";
            this.stepper.previous();
            this.setActiveStep();
            this.openSnackBar("Se rechazo la evaluación y se cambió el estado a "+status,"Cerrar");
             window.location.reload();
          },
          err => {
            this.openSnackBar("No se pudo modificar el estado, ocurrió un error.","Cerrar");
          });
        }
      });

    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 3000,
      });
    }


    actualizarProbabilidadRiesgo(riesgo){

      this.evaluacion.riesgos.forEach(rig => {

        if(rig.riesgo.id == riesgo.riesgo.id &&
          rig.objetivo.id != riesgo.objetivo.id &&
          rig.topAnalisisInherente.probabilidad!= null &&
          rig.topAnalisisInherente.probabilidad!= riesgo.topAnalisisInherente.probabilidad){
            this.probabilidadChange(rig,riesgo.topAnalisisInherente.probabilidad);
        }

      });
    }

    //Cuando se modifica la probabilidad de 1 riesgo, debe cambiar la probabilidad en todos los riesgos de la misma.
    actualizarRiesgosPorCambioDeEvaluacion(){

      this.evaluacion.riesgos.forEach(riesgo => {

        for(var i=0; riesgo.analisisInherente.length>i;i++){

          var impacto = this.findImpactoEquivalente(riesgo.analisisInherente[i].impacto);
          riesgo.analisisInherente[i].impacto = impacto;
        }

        for(var i=0; riesgo.analisisResidual.length>i;i++){

          var impacto = this.findImpactoEquivalente(riesgo.analisisResidual[i].impacto);
          riesgo.analisisResidual[i].impacto = impacto;
          var probabilidad = this.findProbabilidadEquivalente(riesgo.analisisResidual[i].probabilidad);
          riesgo.analisisResidual[i].probabilidad = probabilidad;
        }

        var probabilidadEquivalente = this.findProbabilidadEquivalente(riesgo.topAnalisisInherente.probabilidad);

        this.probabilidadChange(riesgo,probabilidadEquivalente);

      });
    }

    findImpactoEquivalente(impacto){

      var equivalente = null;
      var difEquivalente = 0;

      for(var i=0; this.evaluacion.escenario.impactos.length>i;i++){
        if(equivalente==null){
          equivalente = this.evaluacion.escenario.impactos[i];
          difEquivalente = Math.abs(impacto.valor - this.evaluacion.escenario.impactos[i].valor);
        }else{
          var difImpacto = Math.abs(impacto.valor - this.evaluacion.escenario.impactos[i].valor);
          if(difImpacto<difEquivalente){
            equivalente = this.evaluacion.escenario.impactos[i];
            difEquivalente = difImpacto;
          }
        }
      }

      return equivalente;

    }

    findProbabilidadEquivalente(probabilidad){

      var equivalente = null;
      var difEquivalente = 0;

      for(var i=0; this.evaluacion.escenario.probabilidades.length>i;i++){
        if(equivalente==null){
          equivalente = this.evaluacion.escenario.probabilidades[i];
          difEquivalente = Math.abs(probabilidad.valor - this.evaluacion.escenario.probabilidades[i].valor);
        }else{
          var difProbabilidad = Math.abs(probabilidad.valor - this.evaluacion.escenario.probabilidades[i].valor);
          if(difProbabilidad<difEquivalente){
            equivalente = this.evaluacion.escenario.probabilidades[i];
            difEquivalente = difProbabilidad;
          }
        }
      }

      return equivalente;

    }


    probabilidadChange(riesgo,probabilidad):void{

      for(var i=0; riesgo.analisisInherente.length>i;i++){

        riesgo.analisisInherente[i].probabilidad = probabilidad;
        riesgo.analisisInherente[i] = this.updateProbabilidad(riesgo.analisisInherente[i]);

      }
      
      riesgo.analisisInherente = [...riesgo.analisisInherente];

      for(var i=0; riesgo.analisisResidual.length>i;i++){

        riesgo.analisisResidual[i].probabilidad = probabilidad;
        riesgo.analisisResidual[i] = this.updateProbabilidadResidual(riesgo.analisisResidual[i]);

      }

      riesgo.analisisResidual = [...riesgo.analisisResidual];

      riesgo.topAnalisisInherente = null;

      riesgo.analisisInherente.forEach(ai => {
        if(riesgo.topAnalisisInherente==null){
          riesgo.topAnalisisInherente= ai;
        }else if(riesgo.topAnalisisInherente.exposicion<ai.exposicion){
          riesgo.topAnalisisInherente= ai;
        }
      });

      riesgo.analisisResidual.forEach(ai => {
        if(riesgo.topAnalisisResidual==null){
          riesgo.topAnalisisResidual= ai;
        }else if(riesgo.topAnalisisResidual.exposicion<ai.exposicion){
          riesgo.topAnalisisResidual= ai;
        }
      });


    }

    actualizarAnalisisResidual(objetivoRiesgo){

      for(var i=0; objetivoRiesgo.analisisResidual.length>i;i++){

        // IMPORTANTE; SE SACA EL IF PORQUE GRACIELA EL 1/10/2024 dijo que siempre se tenia que actualizar
          if(objetivoRiesgo.analisisResidual[i].exposicion> objetivoRiesgo.topAnalisisInherente.exposicion)
            objetivoRiesgo.analisisResidual[i].exposicion = objetivoRiesgo.topAnalisisInherente.exposicion;
            objetivoRiesgo.analisisResidual[i].probabilidad = objetivoRiesgo.topAnalisisInherente.probabilidad;
            objetivoRiesgo.analisisResidual[i].impacto = objetivoRiesgo.topAnalisisInherente.impacto;
            objetivoRiesgo.analisisResidual[i].clasificacion = objetivoRiesgo.topAnalisisInherente.clasificacion;
      }

      objetivoRiesgo.topAnalisisResidual = null;
      for(var i=0; objetivoRiesgo.analisisResidual.length>i;i++){

        if(objetivoRiesgo.topAnalisisResidual == null || objetivoRiesgo.topAnalisisResidual.exposicion ==0 ||
            objetivoRiesgo.analisisResidual[i].exposicion< objetivoRiesgo.topAnalisisResidual.exposicion)
            objetivoRiesgo.topAnalisisResidual = objetivoRiesgo.analisisResidual[i];
      }

    }

    updateProbabilidad(analisisInherente):AnalisisInherente{

      var clonado: AnalisisInherente = new AnalisisInherente(analisisInherente);
      //clonado.probabilidad =  this.probabilidad;
      const parser = new Parser();
      var expression = parser.parse(this.evaluacion.escenario.formulaDeExposicion);
      var exposicion = expression.evaluate({ P: clonado.probabilidad.valor, I: clonado.impacto.valor });
      clonado.exposicion = exposicion;

      var clasificacion = "Aceptable";
      if(exposicion>=this.evaluacion.escenario.apetito)
        clasificacion = "Atención";

        if(exposicion>=this.evaluacion.escenario.tolerancia)
          clasificacion = "Inaceptable";

      clonado.clasificacion = clasificacion;

      return clonado;
    }

    //PUEDE QUE SE TENGA QUE SACAR. ES UNA PRUEBA
    updateProbabilidadResidual(analisisResidual):AnalisisResidual{

      var clonado: AnalisisResidual = new AnalisisResidual(analisisResidual);
      //clonado.probabilidad =  this.probabilidad;
      const parser = new Parser();
      var expression = parser.parse(this.evaluacion.escenario.formulaDeExposicion);
      var exposicion = expression.evaluate({ P: clonado.probabilidad.valor, I: clonado.impacto.valor });
      clonado.exposicion = exposicion;

      var clasificacion = "Aceptable";
      if(exposicion>=this.evaluacion.escenario.apetito)
        clasificacion = "Atención";

        if(exposicion>=this.evaluacion.escenario.tolerancia)
          clasificacion = "Inaceptable";

      clonado.clasificacion = clasificacion;

      return clonado;
    }

    calcularAnalisisInherente(riesgo):void{

      if(riesgo.topAnalisisInherente.probabilidad!=null &&
        riesgo.topAnalisisInherente.impacto!=null){

        riesgo.analisisInherente = [];

        const parser = new Parser();
        var expression = parser.parse(this.evaluacion.escenario.formulaDeExposicion);
        var exposicion = expression.evaluate({ P: riesgo.topAnalisisInherente.probabilidad.valor, I: riesgo.topAnalisisInherente.impacto.valor });
        riesgo.topAnalisisInherente.exposicion = exposicion;

        var clasificacion = "Aceptable";
        if(exposicion>=this.evaluacion.escenario.apetito)
          clasificacion = "Atención";

        if(exposicion>=this.evaluacion.escenario.tolerancia)
          clasificacion = "Inaceptable";

        riesgo.topAnalisisInherente.clasificacion = clasificacion;
        riesgo.analisisInherente.push(riesgo.topAnalisisInherente);

        if(riesgo.analisisResidual.length==0 && riesgo.topAnalisisInherente!=null){
          var new_line_r = new AnalisisResidual({});
          new_line_r.probabilidad = riesgo.topAnalisisInherente.probabilidad;
          new_line_r.impacto = riesgo.topAnalisisInherente.impacto;
          new_line_r.exposicion = riesgo.topAnalisisInherente.exposicion;
          new_line_r.clasificacion = riesgo.topAnalisisInherente.clasificacion;
          riesgo.analisisResidual.push(new_line_r);
          riesgo.topAnalisisResidual = new_line_r;
          riesgo.analisisResidual = [...riesgo.analisisResidual];
          riesgo.topAnalisisResidual = {...riesgo.topAnalisisResidual};

        }

        this.actualizarProbabilidadRiesgo(riesgo);

        this.actualizarAnalisisResidual(riesgo);

        this.service.edit(this.evaluacion.id,this.evaluacion).pipe().subscribe(req => {
          //this.openSnackBar("Se actualizó el riesgo correctamente.","Cerrar");
          //this.evaluacion = {...this.evaluacion};
        },
        err => {
          this.openSnackBar("No se pudo actualizar el riesgo, ocurrió un error.","Cerrar");

        });

      }

    }

    compareObjects(o1: any, o2: any): boolean {
      return o1.nombre === o2.nombre && o1.id === o2.id;
    }

    esOwnersGroup(usuario):boolean{

      var esOwner:boolean = false;

      usuario.tipos.forEach(element => {
        if(element.id == 4)
          esOwner = true;
      });

      return esOwner;
    }

    public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
      console.log(tabChangeEvent);
      console.log("Entro a tabChanged para actualizar los resultados");
      if(tabChangeEvent.tab.textLabel=="Análisis Residual"){
        this.actualizo_heatmap = false;
        this.actualizarColores();
      }
    }

    async actualizarColores(){
      
      console.log("Entro a actualizarColores para actualizar los colores del tablero.");
      var elementosAActualizar = document.querySelectorAll('[ngx-charts-heat-map-cell]');

      if(!this.actualizo_heatmap && elementosAActualizar!=null && elementosAActualizar.length>0){
        
        this.calculateColorsValue();
        this.updateChartTexts();

      }else{
        if(!this.actualizo_heatmap){
          await this.delay(1000);
          this.actualizarColores();
        }
      }
    }

    delay(ms: number) {
      return new Promise( resolve => setTimeout(resolve, ms) );
    }

    updateChartTexts(){
      var width = 20,
        barHeight = 20;

      var chart = d3.select(".ngx-charts");
      var bar = chart.selectAll("g.cell");

      bar.append("text")
        .attr("dy", "1.65em")
        .attr("dx", "1em")
        .attr("class", "rec_text")
        .attr("style", "font-size:20px;")
        .text(function(d) {
          var val= this.parentNode.parentNode.getAttribute("ng-reflect-data");
          var cantidad = this.parentNode.parentNode.getAttribute("cantidad");

          return cantidad; });

          setTimeout(() =>
            {
                this.view= [700, 355];
            },
            1000);

    }


    calculateColorsValue(){

      this.pieDataExposiciones = [];
      this.riesgosAgregados = [];
      var valoresYaEvaluados = [];
      this.riesgosTooltip = {};
      var elementosAActualizar = document.querySelectorAll('[ngx-charts-heat-map-cell]');
      console.log("Cantidad de nodos:"+ elementosAActualizar.length);
      var nodo = elementosAActualizar[0];
      var val= nodo.getAttribute('ng-reflect-data');
      console.dir("NO SE ENCONTRO NODO con 'ng-reflect-data'");
      console.dir(nodo);
      var iProbabilidad = 0;
      var iImpacto = 0;
      const parser = new Parser();
      var expression = parser.parse(this.evaluacion.escenario.formulaDeExposicion);
      for(var i = 0; i< elementosAActualizar.length;i++){

        nodo = elementosAActualizar[i];
        //console.dir(nodo);
        var colorRecuadro = this.customColors[i].value;
        nodo.children[0].children[0].setAttribute("fill",colorRecuadro);
        var probabilidadVal = this.evaluacion.escenario.probabilidades[iProbabilidad].valor;
        var impactoVal = this.evaluacion.escenario.impactos[iImpacto].valor;
        val= expression.evaluate({ P: probabilidadVal, I: impactoVal });
        
        var cantidad = 0;
        //Si no se evaluo aun ese valor.
        if(valoresYaEvaluados.indexOf(val)==-1){
          val = Number(val).toFixed(2);
          cantidad = this.contarCantidadEntreValores(val,impactoVal,probabilidadVal,this.resultsList);
          valoresYaEvaluados.push(val);
        }else{
          console.log("Valor ya evaluado:"+val);
        }

        nodo.setAttribute('cantidad',cantidad.toString());
        console.log("Valor: "+val+" cantidad del nodo: "+nodo.getAttribute('cantidad') + " cantidad encontrada:"+cantidad);

        if(cantidad>0)
          this.pieDataExposiciones.push({name:Number(val).toFixed(2).toString(),value:cantidad});

        iImpacto += 1;
        if(iImpacto>= this.evaluacion.escenario.impactos.length){
          iImpacto =0;
          iProbabilidad += 1;
        }

        this.pieDataExposiciones = [...this.pieDataExposiciones];
        this.actualizo_heatmap = true;
      }
    }

    //Resultados son las exposiciones de los analisis residuales nuevos calculados.
    contarCantidadEntreValores(result,iImpacto,iProbabilidad,resultados):number{

      resultados.sort((a, b) => (a > b) ? 1 : -1);
      var cantidad = 0;
      var min = 0;
      var max = result;

      for(var i=0;i<resultados.length;i++){
          if(resultados[i]==result){
            if(i==(resultados.length-1))
              max = 100000000;

            if(i>1){
              min= resultados[i-1];
              break;
            }

          }
      }

      result = Number(result);

      var listaRiesgos = [];

      this.evaluacion.riesgos.forEach(riesgo => {

        var pasa = false;
        if(riesgo.topAnalisisResidual!=null && riesgo.topAnalisisResidual.exposicion!=null)
          
          /*
          var resultExposicion = Number(riesgo.topAnalisisResidual.exposicion.toFixed(2));  
          if(resultExposicion>=min && resultExposicion<=max &&
              this.riesgosAgregados.indexOf(riesgo.id)==-1){
                pasa= true;
          }*/

          
          if(riesgo.topAnalisisResidual.probabilidad.valor==iProbabilidad && riesgo.topAnalisisResidual.impacto.valor==iImpacto &&
            this.riesgosAgregados.indexOf(riesgo.id)==-1){
              pasa= true;
          }

          if(pasa){
            cantidad+=1;
            console.log("Entro al Minimo: "+min+" Resultado: "+result+" con expo "+riesgo.topAnalisisResidual.exposicion );
            this.riesgosAgregados.push(riesgo.id);

            var cardinal = iProbabilidad +","+iImpacto;
            
            if(this.riesgosTooltip[cardinal]== null)
              this.riesgosTooltip[cardinal] = {"impacto": iImpacto, "probabilidad": iProbabilidad, "riesgos": []};

            this.riesgosTooltip[cardinal]["riesgos"].push(riesgo);
          }
      });

      return cantidad;

    }

    calcularResultadosOriginal(){

      console.log("Entro a calcularResultadosOriginal para actualizar los resultados");
      this.dataSource = this.evaluacion.escenario.probabilidades || [];
      this.dataSourceI = this.evaluacion.escenario.impactos || [];

      this.dataSourceR = [];
      this.multi = [];

      this.dataSourceI.sort((a, b) => (a.valor > b.valor) ? 1 : -1);
      this.dataSourceI = [...this.dataSourceI];
      this.dataSource.sort((a, b) => (a.valor > b.valor) ? 1 : -1);
      this.dataSource = [...this.dataSource];
      this.customColors = [];

      this.resultsList = [];

      for(var f=0; this.dataSource.length>f;f++){
        for(var x=0; this.dataSourceI.length>x;x++){
          const parser = new Parser();
          var expression = parser.parse(this.evaluacion.escenario.formulaDeExposicion);
          var result = expression.evaluate({ P: this.dataSource[f].valor, I:this.dataSourceI[x].valor });
          this.resultsList.push(result);
        }
      }

      if(this.evaluacion.escenario.formulaDeExposicion!=null){

        for(var i=0; this.dataSource.length>i;i++){

            var chartV ={"name": this.dataSource[i].nombre +" ("+this.dataSource[i].valor+")",
                          "series": []
                          };

          for(var z=0; this.dataSourceI.length>z;z++){
            const parser = new Parser();
            //let expr = parser.parse('2 * x + 1');
            //console.log(expr.evaluate({ x: 3 })); // 7
            var expression = parser.parse(this.evaluacion.escenario.formulaDeExposicion);
            var result = expression.evaluate({ P: this.dataSource[i].valor, I:this.dataSourceI[z].valor });
            this.dataSourceR.push({probabilidad:this.dataSource[i], impacto:this.dataSourceI[z],resultado:result});
            var nombre_evaluacion = (this.dataSourceI[z].nombre!=null && this.dataSourceI[z].nombre.length>50) ? this.dataSourceI[z].nombre.substring(0,50) +"..." : this.dataSourceI[z].nombre;

            result = Number(result.toFixed(2));
            chartV["series"].push({
                                  "name":nombre_evaluacion +" ("+this.dataSourceI[z].valor+")",
                                   "value":  result
                                 });
            var color = '#34C229';

            if(result>=this.evaluacion.escenario.apetito)
              color =  '#F1F80C';

            if(result>=this.evaluacion.escenario.tolerancia)
              color =  '#E44D25';

            this.customColors.push({"name":nombre_evaluacion +" ("+this.dataSourceI[z].valor+")","value":color});
            this.customColorsPie.push({"name":result.toString(),"value":color});
          }

          this.multi.push(chartV);
        }

        this.customColors = [...this.customColors];
        this.customColorsPie = [...this.customColorsPie];
        this.dataSourceR = [...this.dataSourceR];

        //this.updateChartTexts();
        //this.actualizarColores();

      }
  }

  tooltipText(data) {
    //const label = formatLabel(data.name);
    //const val = formatLabel(data.value);
    /* data = name:"Medio  (3)" //Impacto
              series:"Baja  (2)" //Probabilidad
              value: 2.6*/

    var impacto = Number(data.name.match(/\d+/)[0]);
    var probabilidad = Number(data.series.match(/\d+/)[0]);

    var textoTooltip = '';

    //var objetivos = this.contarObjetivosEntreValores(data.value);
    var cardinal = probabilidad +","+impacto;
    //var cardinal = data.value;
    if(this.riesgosTooltip[cardinal]!=null)

       if(this.riesgosTooltip[cardinal]["probabilidad"] == probabilidad  &&
          this.riesgosTooltip[cardinal]["impacto"] == impacto){

        this.riesgosTooltip[cardinal]["riesgos"].forEach(element => {
          var nombre_objetivo = (element.objetivo.nombre!=null && element.objetivo.nombre.length>75) ? element.objetivo.nombre.substring(0,75) +"..." : element.objetivo.nombre;
          var nombre_riesgo = (element.riesgo.nombre!=null && element.riesgo.nombre.length>75) ? element.riesgo.nombre.substring(0,75) +"..." : element.riesgo.nombre;
          textoTooltip+=`<span class="tooltip-label" >${nombre_objetivo} - ${nombre_riesgo}</span>`;
        });
    }

    return textoTooltip;
  }

  

}
